<template>
  <div class="row">
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
          />
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="informatiza-aps"
          >
          </download-files>
        </div>
      </div>
      <v-app class="app-tabela">
        <div class="box" style="margin-top: 0px">
          <v-card class="tabela">
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Nome da equipe"
                class="input-bottom"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              @pagination="getPagination"
              :page="currentPage"
              :footer-props="{
                itemsPerPageText: '',
                'items-per-page-options': [10],
                'disable-items-per-page': true,
              }"
              :loading="loading"
              loading-text="Carregando, Por favor espere"
              :headers="headers"
              :item-class="getRowColor"
              :items="displayedCadastros"
              :search="search"
              :single-expand="false"
              :expanded.sync="expanded"
              item-key="id"
              :show-expand="true"
              class="elevation-1"
            >
              <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
              <template v-slot:[`footer.page-text`]="items">
                <div class="info-table-item tabela-esus-pec">
                  <p class="fonte">
                    <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
                  </p>
                </div>
                <span class="paginacao"
                  >{{ items.pageStart }} - {{ items.pageStop }} de
                  {{ items.itemsLength }} equipes</span
                >
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td
                  colspan="6"
                  class="table-interna-informatiza-aps text-center"
                >
                  <table class="table table-interna" style="margin: 20px 0">
                    <thead>
                      <tr>
                        <th>Função</th>
                        <th
                          v-for="(item2, index2) in item.atendimentos"
                          :key="index2"
                        >
                          {{ item2.mes_atend }}
                        </th>
                        <th>Parâmetro</th>
                        <th>Diferença</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="item.atendimentos.length > 0">
                        <td>Enfermeiro</td>
                        <td
                          v-for="(item3, index3) in item.atendimentos"
                          :key="index3"
                          :class="
                            Number(item3.enfermeiro) <
                            Number(parametro_enfermeiro)
                              ? 'color-red'
                              : 'color-green'
                          "
                        >
                          <div class="d-block mb-2">
                            {{ item3.enfermeiro }}
                          </div>
                        </td>
                        <td>
                          {{ parametro_enfermeiro }}
                        </td>
                        <td
                          :class="
                            Number(
                              item.atendimentos[item.atendimentos.length - 1]
                                .enfermeiro
                            ) -
                              Number(parametro_enfermeiro) <
                            0
                              ? 'color-red'
                              : 'color-green'
                          "
                        >
                          {{
                            Number(
                              item.atendimentos[item.atendimentos.length - 1]
                                .enfermeiro
                            ) - Number(parametro_enfermeiro)
                          }}
                        </td>
                      </tr>
                      <tr v-if="item.atendimentos.length > 0">
                        <td>Médico</td>
                        <td
                          v-for="(item3, index3) in item.atendimentos"
                          :key="index3"
                          :class="
                            Number(item3.medico) < Number(parametro_medico)
                              ? 'color-red'
                              : 'color-green'
                          "
                        >
                          <div class="d-block mb-2">
                            {{ item3.medico }}
                          </div>
                        </td>
                        <td>
                          {{ parametro_medico }}
                        </td>
                        <td
                          :class="
                            Number(
                              item.atendimentos[item.atendimentos.length - 1]
                                .medico
                            ) -
                              Number(parametro_medico) <
                            0
                              ? 'color-red'
                              : 'color-green'
                          "
                        >
                          {{
                            Number(
                              item.atendimentos[item.atendimentos.length - 1]
                                .medico
                            ) - Number(parametro_medico)
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </template>

              <template v-slot:progress>
                <v-progress-linear
                  color="blue"
                  :height="10"
                  indeterminate
                ></v-progress-linear>
              </template>
              <template v-slot:no-data>
                <div class="alert alert-info mb-0">
                  <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
                </div>
              </template>
              <template v-slot:no-results style="padding: 0px">
                <div class="alert alert-info mb-0">
                  <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-app>
    </div>
  </div>
</template>

<script>
import Subtitle from './Subtitle.vue'
import * as Functions from './functions.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'InformatizaAps',
  components: {
    Subtitle,
    DownloadFiles,
  },
  filters: {
    capitalize: function (value) {
      return value.toUpperCase()
    },
  },
  data() {
    return {
      parametro_medico: 0,
      parametro_enfermeiro: 0,
      atendimentos_medico: 0,
      atendimentos_enfermeiro: 0,
      no_cbo_medico: '',
      no_cbo_enfermeiro: '',
      atendimentos: [],
      loading: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      mesAtual: '',
      mesAnterior: '',
      mesAnteAnterior: '',
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'UNIDADE DE SAÚDE',
          align: 'start',
          filterable: true,
          value: 'no_unidade_de_saude',
        },
        {
          text: 'EQUIPE',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: false,
          value: 'nu_ine',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
      cadastrosOriginais: [],
      months: [],
      monthsTable: [],
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      const data = this.atendimentos.map((item, index) => ({
        id: index,
        ...item,
      }))
      this.expanded = data
      return data
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    filtros(vermelho, verde) {
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(
          data,
          this.parametro_enfermeiro,
          this.parametro_medico
        )
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(
          data,
          this.parametro_enfermeiro,
          this.parametro_medico
        )
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.atendimentos = data
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    // Busca os dados referentes a cidade ao abrir a página
    async buscarDadosIniciais() {
      this.loading = true
      try {
        let parametro = await this.$api.get(
          '/app/infomatiza-aps/parametro/' + this.$store.state.cod_ibge
        )
        if (parametro) {
          this.parametro_medico = parametro.data.medico_esf
          this.parametro_enfermeiro = parametro.data.enfermeiro_esf

          var data_atual = new Date()
          var mes = String(data_atual.getMonth() + 1).padStart(2, '0')

          let response = await this.$api.get(
            '/app/infomatiza-aps/atendimentos/' + this.$store.state.cod_ibge
          )
          if (response) {
            this.atendimentos = response.data
            const groupedData = this.groupData(this.atendimentos, 'nu_ine')
            let customData = []
            for (const key in groupedData) {
              let atendimentos = groupedData[key].sort(function (a, b) {
                a = a.mes_atend.split('/')
                b = b.mes_atend.split('/')
                return new Date(a[1], a[0], 1) - new Date(b[1], b[0], 1)
              })
              customData.push({
                no_unidade_de_saude: groupedData[key][0].no_unidade_saude,
                no_equipe: groupedData[key][0].no_equipe,
                nu_ine: groupedData[key][0].nu_ine,
                atendimentos: atendimentos.slice(-6),
              })
            }
            this.cadastrosOriginais = customData
            this.atendimentos = customData
            this.loading = false
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    /**
     * Agrupa os objetos de um array de acordo com a chave passada
     * @param {Array} arrayData - Array de objetos
     * @param {String} key - Chave para controle de agrupamento
     */
    groupData(arrayData, key) {
      return arrayData.reduce((result, currentValue) => {
        // Se uma matriz já estiver presente para a chave, empurre-a para a matriz. Caso contrário, crie uma matriz e empurre o objeto
        ;(result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        )
        // Retorne o valor `result` da iteração atual, isso será considerado como o valor `result` da próxima iteração e acumulará
        return result
      }, {}) // objeto vazio é o valor inicial para objeto de resultado
    },

    retornaNomeDoMes(mes) {
      const month = new Array()
      month[1] = 'Janeiro'
      month[2] = 'Fevereiro'
      month[3] = 'Março'
      month[4] = 'Abril'
      month[5] = 'Maio'
      month[6] = 'Junho'
      month[7] = 'Julho'
      month[8] = 'Agosto'
      month[9] = 'Setembro'
      month[10] = 'Outubro'
      month[11] = 'Novembro'
      month[12] = 'Dezembro'
      return month[mes]
    },

    getRowColor(item) {
      let ultimo_atendimento_enfermeiro =
        item.atendimentos[item.atendimentos.length - 1].enfermeiro
      let ultimo_atendimento_medico =
        item.atendimentos[item.atendimentos.length - 1].medico
      if (
        Number(
          ultimo_atendimento_enfermeiro - Number(this.parametro_enfermeiro) < 0
        ) ||
        Number(ultimo_atendimento_medico - Number(this.parametro_medico) < 0)
      ) {
        return 'color-red'
      } else {
        return 'color-green'
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.atendimentos,
        this.parametro_enfermeiro,
        this.parametro_medico
      )
    },

    init() {
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.green,
.color-green {
  color: green;
}
.red,
.color-red {
  color: red;
}

.table-interna-informatiza-aps h3 {
  font-size: 16px;
  margin-top: 20px;
}

@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
</style>
